'use client';

import React, { useState, useRef, useEffect } from 'react';
import { Box, Text } from '@skin-seoul/design-system';
import DropdownTrigger from './DropdownTrigger';
import DropdownContainer from './DropdownContainer';
import type { DropdownOptionStatus } from './DropdownOption';
import DropdownOption from './DropdownOption';
export interface DropdownItem {
  label: string;
  value: string;
  status: DropdownOptionStatus;
  disabled?: boolean;
}
export interface DropdownProps {
  items: DropdownItem[];
  selectedValue?: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  label?: string;
}
const Dropdown = ({
  items,
  selectedValue,
  onValueChange,
  placeholder = 'Select an option',
  disabled = false,
  label
}: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };
  const handleOptionClick = (value: string) => {
    onValueChange(value);
    setIsOpen(false);
  };
  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const selectedItem = items.find(item => item.value === selectedValue);
  const processedItems = items.map(item => ({
    ...item,
    status: (item.value === selectedValue && item.status !== 'outofstock' ? 'selected' : item.status === 'selected' ? 'instock' : item.status) as DropdownOptionStatus
  }));
  return <Box position="relative" width="100%" ref={dropdownRef} data-sentry-element="Box" data-sentry-component="Dropdown" data-sentry-source-file="Dropdown.tsx">
      {label && <Text textStyle={{
      base: 'paragraph.small',
      tablet: 'paragraph.medium'
    }} color="neutral.400" marginBottom={3}>
          {label}
        </Text>}

      <DropdownTrigger selectedValue={selectedItem?.label || ''} isOpen={isOpen} onClick={handleToggle} disabled={disabled} placeholder={placeholder} data-sentry-element="DropdownTrigger" data-sentry-source-file="Dropdown.tsx" />

      <DropdownContainer isOpen={isOpen} data-sentry-element="DropdownContainer" data-sentry-source-file="Dropdown.tsx">
        {processedItems.map(item => <DropdownOption key={item.value} label={item.label} status={item.status} onClick={() => handleOptionClick(item.value)} disabled={item.disabled || item.status === 'outofstock'} />)}
      </DropdownContainer>
    </Box>;
};
export default Dropdown;